<template>
  <b-form @submit.prevent>
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <small class="d-block">#{{ pedidoId }}</small>
            <b>Pedido</b>
          </div>

          <router-link
            :to="$routeBack('pedidos_list')"
            class="btn btn-outline-muted"
          >
            Voltar para Listagem
          </router-link>
        </div>
      </template>

      <div class="p-4">
        <p class="text-muted mb-0">Já já fica bão</p>
      </div>
    </b-card>
  </b-form>
</template>

<script>
export default {
  computed: {
    pedidoId() {
      return this.$route.params.id || "-";
    },
  },
};
</script>

<style></style>
